import {
  BurgerMenu,
  SideNavigation,
  SideNavigationProps,
  styled,
} from '@zeiss/beyond-online-react';
import { useBreakpoint } from '@zeiss/lib-helpers';

interface StyledSideNavigationProps {
  $isFooterVisible?: boolean;
}

const StyledSideNavigation = styled(SideNavigation)<StyledSideNavigationProps>`
  position: sticky;

  --header-height: 64px;
  --footer-height: ${({ $isFooterVisible: isFooterVisible }) =>
    isFooterVisible ? '38px' : '0px'};

  /* Offset by header height and top margin */
  top: calc(var(--header-height) + var(--spacing-s));

  /* Subtract header, footer, margin heights */
  height: calc(
    100vh - (var(--header-height) + var(--footer-height) + 2 * var(--spacing-s))
  );
  margin: var(--spacing-s);
  margin-inline-end: 0;

  /* Beyond Displays the black 'info belt' section from this breakpoint */
  @media (width > 768px) {
    --header-height: 88px;
  }
`;

interface NavigationProps {
  applicationTitle: string;
  isFooterVisible: boolean;
  navigationGroups: SideNavigationProps['groups'];
  /**
   * Burger menu open state. Used to display the mobile menu
   */
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Navigation = ({
  applicationTitle,
  isFooterVisible,
  navigationGroups,
  open,
  setOpen,
}: NavigationProps) => {
  const isMinTablet = useBreakpoint('tablet');

  const closeBurgerMenu = () => setOpen(false);

  if (isMinTablet) {
    return (
      <StyledSideNavigation
        $isFooterVisible={isFooterVisible}
        expanded={isMinTablet}
        groups={navigationGroups}
      />
    );
  }

  return (
    <BurgerMenu
      groups={navigationGroups}
      onClose={closeBurgerMenu}
      open={open}
      title={applicationTitle}
    />
  );
};
